<div class="row">

	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				*ngIf="project?.isDraft && !usercompanyid"
				class="float-right btn btn-sm btn-primary"
				(click)="edit(null)">
				<i
					container="body"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					[messages]="{
          emptyMessage: 'labels.empty-partecipants' | translate,
          totalMessage: 'labels.total' | translate
		}">
					<!-- ID -->
					<ngx-datatable-column
						prop="eid"
						[flexGrow]="0.5"
						[name]="'partecipant.id' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>
					<!-- TIPO -->
					<ngx-datatable-column
						prop="entity"
						[flexGrow]="1"
						[name]="'partecipant.entity' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{ 'labels.' + value | translate}}
						</ng-template>
					</ngx-datatable-column>
					<!-- NOME -->
					<ngx-datatable-column
						prop="entityobj"
						[flexGrow]="2"
						[name]="'partecipant.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								*ngIf="!usercompanyid || (row.isCompany && usercompanyid === value.id)"
								class="link"
								[routerLink]="row.isCompany ? '/company/view/' + value.id : '/consultant/view/' + value.id">
								{{value.name}}
							</a>
							<span *ngIf="usercompanyid && usercompanyid !== value.id">{{value.name}}</span>

						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="docvalid"
						[flexGrow]="0.5"
						[name]="''"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<i
								*ngIf="row.entityobj.docvalid"
								container="body"
								ngbTooltip="{{'labels.docvalid' | translate}}"
								class="icon-valid feather icon-check-circle"></i>

							<i
								*ngIf="!row.entityobj.docvalid"
								container="body"
								ngbTooltip="{{'labels.docinvalid' | translate}}"
								class="icon-invalid feather icon-alert-octagon"></i>
						</ng-template>
					</ngx-datatable-column>

					<!-- BUDGET -->
					<ngx-datatable-column
						prop="budget"
						[flexGrow]="2"
						[name]="'partecipant.budget' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{ value | currency:'EUR'}}
						</ng-template>
					</ngx-datatable-column>

					<!-- BUDGET -->
					<ngx-datatable-column
						*ngIf="project?.reporting"
						[flexGrow]="3.5"
						[name]="'labels.reporting-monitoring' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="row">
								<div class="col-5">
									{{row.currentcost | currency: '€'}} / {{row.realbudget | currency: '€'}}
								</div>
								<div class="col-6">
									<p>
										<ngb-progressbar
											type="primary"
											[value]="row.currentcost / row.realbudget * 100"
											[striped]="true"
											[animated]="true">
											<span *ngIf="(row.currentcost / row.realbudget * 100) > 5">
												{{(row.currentcost / row.realbudget * 100) | number : '1.0-0'}} %
											</span>
										</ngb-progressbar>
									</p>
								</div>
								<div class="col-1">
									<ng-template [ngIf]="project.reporting">
										<i
											class="fa fa-search-plus"
											[ngbTooltip]="HtmlContent"
											(mouseenter)="hoverPartecipant = row"
											container="body"
											contentType="template"></i>
									</ng-template>
								</div>
							</div>

						</ng-template>
					</ngx-datatable-column>

					<!-- LEADER -->
					<ngx-datatable-column
						prop="leader"
						[flexGrow]="1"
						[name]="'partecipant.leader' | translate"
						[resizeable]="false">

						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">
								<i
									*ngIf="value"
									class="icon-valid fas fa-check"></i>
							</div>

						</ng-template>

					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">

								<a class="link {{!row.roledescr ? 'hide' : ''}}">
									<i
										container="body"
										ngbTooltip="{{row.roledescr}}"
										class="feather icon-help-circle"></i>
								</a>
								<a
									(click)="edit(row.id)"
									class="link"
									*ngIf="project?.isDraft && !usercompanyid">
									<i
										container="body"
										ngbTooltip="{{'labels.edit' | translate}}"
										class="feather icon-edit"></i>
								</a>
								<a
									(click)="delete(row, $event)"
									class="link"
									*ngIf="project?.isDraft && !usercompanyid">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>

<ng-template #HtmlContent>
	<p *ngFor="let key of hoverPartecipant.costperactivitytaxonomy | keys">
		{{'labels.' + key | translate}}: {{hoverPartecipant.costperactivitytaxonomy[key] / 100 | currency: '€'}} ({{hoverPartecipant.costperactivitytaxonomy[key] / hoverPartecipant?.totcostperactivity * 100 | number: '1.0-0'}} %)
	</p>

</ng-template>
